import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DCSParent = lazy(() => import("./DCSParent"));

const DCS_PARENT_ROUTES: RouteObject[] = [
  {
    path: "/private/dcs",
    element: React.createElement(DCSParent),
  },
];

export default DCS_PARENT_ROUTES;
